import { createStore } from 'vuex'

export const store = createStore({
    state() {
        return {
            date: [],
            selectedTypes: [],
            selectedGenders: [],
            selectedStates: [],
            rtl: localStorage.getItem('lang') == 'ar'
        }
    },
}) 